import createReactComponent from '../createReactComponent';
export default createReactComponent('caret-down', 'IconCaretDown', [
  ['path', { d: 'M6 10l6 6l6 -6h-12', key: 'svg-0' }],
]);
